export const SET_TOKEN_REQUSET = "SET_TOKEN_REQUSET"
export const SET_TOKEN_SUCCESS = "SET_TOKEN_SUCCESS"
export const SET_TOKEN_FAILURE = "SET_TOKEN_FAILURE"

const initialState = {
	token: "",
	errorMessage: "",
}
export const setToken = (token) => (dispatch) => {
	dispatch({
		type: SET_TOKEN_SUCCESS,
		payload: token,
	})
	return Promise.resolve()
}
export default function reducer(state = initialState, action) {
	const { payload, errorMessage } = action
	switch (action.type) {
		case SET_TOKEN_REQUSET: {
			return { ...state, errorMessage: "" }
		}
		case SET_TOKEN_SUCCESS: {
			return { ...state, token: payload }
		}
		case SET_TOKEN_FAILURE: {
			return { ...state, errorMessage }
		}
		default: {
			return state
		}
	}
}



// WEBPACK FOOTER //
// ./src/redux/modules/SetTokenRes.js